/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Error_UpdateInputs */



/**
* | output |
* | --- |
* | "Couldn't update the league." |
*
* @param {League_Error_UpdateInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_error_update = /** @type {((inputs?: League_Error_UpdateInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Error_UpdateInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de mettre à jour la ligue.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo actualizar la liga.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível atualizar a liga.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile aggiornare il campionato.")
	return /** @type {LocalizedString} */ ("Couldn't update the league.")
});